import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export default function RequireAuth({ children, roles, branches, perm }) {
  const { user, loading, hasBranchAccess, hasPermission } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-8 text-muted">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (user.must_change_password && loc.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <div className="p-8 text-crimson">Insufficient permissions.</div>;
  }
  if (branches && !hasBranchAccess(branches)) {
    return <div className="p-8 text-crimson">Insufficient permissions.</div>;
  }
  if (perm && !hasPermission(perm)) {
    return <div className="p-8 text-crimson">Insufficient permissions.</div>;
  }
  return children;
}
